<template>
  <nav class="px-2 pb-2 space-y-0.5">
    <template v-for="section in sections" :key="section.key">
      <p v-if="section.label" class="px-2 pt-4 pb-1 text-xs font-semibold text-gray-400 uppercase tracking-wider">
        {{ section.label }}
      </p>
      <router-link
        v-for="item in section.items"
        :key="item.name"
        :to="item.to"
        class="flex items-center px-2 py-1.5 rounded-md group"
        :class="[
          isActiveRoute(item) ? 'text-primary-dark font-medium' : '',
          'group flex items-center px-2 py-1.5 text-sm hover:bg-gray-200 rounded-md text-gray-500',
        ]"
        @click="$emit('close')"
      >
        <component
          :is="item.icon"
          class="h-4 w-4 mr-2"
          :class="isActiveRoute(item) ? 'text-primary-dark' : 'text-gray-400'"
          aria-hidden="true"
        />
        <span>{{ item.name }}</span>
      </router-link>
    </template>
  </nav>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapGetters } from "vuex";
import {
  HomeIcon,
  PresentationChartLineIcon,
  OfficeBuildingIcon,
  ShieldCheckIcon,
  UserGroupIcon,
  UserCircleIcon,
  UsersIcon,
} from "@heroicons/vue/outline";

export default {
  components: {
    HomeIcon,
    PresentationChartLineIcon,
    OfficeBuildingIcon,
    ShieldCheckIcon,
    UserGroupIcon,
    UserCircleIcon,
    UsersIcon,
  },
  emits: ["close"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
  computed: {
    ...mapGetters("auth", ["isInsurerAdmin"]),

    merchantItems() {
      const items = [];
      if (this.isInsurerAdmin) {
        items.push({ name: this.t("organizations"), to: "/organizations", icon: UserGroupIcon });
      }
      items.push({ name: this.t("stores"), to: "/stores", icon: OfficeBuildingIcon });
      items.push({ name: this.t("users"), to: "/users", icon: UserCircleIcon });
      return items;
    },

    sections() {
      const sections = [
        {
          key: "main",
          label: null,
          items: [
            { name: this.t("home"), to: "/home", icon: HomeIcon },
            { name: this.t("pilotage"), to: "/analytics/retail", icon: PresentationChartLineIcon },
            { name: this.t("plan_sales"), to: "/plan-sales", icon: ShieldCheckIcon },
          ],
        },
        {
          key: "merchants",
          label: this.t("merchants"),
          items: this.merchantItems,
        },
      ];

      if (this.isInsurerAdmin) {
        sections.push({
          key: "internal",
          label: this.t("internal"),
          items: [{ name: this.t("internal_users"), to: "/internal/users", icon: UsersIcon }],
        });
      }

      return sections;
    },
  },
  methods: {
    isActiveRoute(item) {
      if (item.to === this.$route.path) return true;
      if (this.$route.path.startsWith(item.to + "/")) return true;
      return false;
    },
  },
};
</script>

<i18n src="./InsurerMenu.i18n.json"></i18n>
